export default __webpack_public_path__ + "static/media/Stad-antwerpen-logo.440f7074.jpg";